import { gql } from '@apollo/client'

import { progressionReportFragments } from './progression'

export const profileQuery = gql`
  query Profile {
    profile {
      id
      isPublic
      createdAt
      discord {
        id
        name
        avatarUrl
      }
      faceit {
        id
        name
        avatarUrl
      }
      steam {
        id
        name
        avatarUrl
      }
    }
  }
`

export const privateProfileQuery = gql`
  query PrivateProfile {
    profile {
      id
      isPublic
      createdAt
      steam {
        id
        name
        avatarUrl
      }
      csgo {
        progressionReport(limit: 9999) {
          ...ProgressionReportFields
        }
      }
    }
  }

  ${progressionReportFragments}
`

// The public profile page issues these three in parallel so a slow field can't
// hold up the whole page: identity settles first (redirect / not-found), then
// steam and the progression report fill in independently.
export const publicProfileQuery = gql`
  query PublicProfile($profileId: ID!) {
    profile: publicProfile(id: $profileId) {
      id
      isPublic
      isOwner
      affiliate {
        code
      }
      createdAt
    }
  }
`

export const publicProfileSteamQuery = gql`
  query PublicProfileSteam($profileId: ID!) {
    profile: publicProfile(id: $profileId) {
      id
      steam {
        id
        name
        avatarUrl
      }
    }
  }
`

export const publicProfileProgressionQuery = gql`
  query PublicProfileProgression($profileId: ID!) {
    profile: publicProfile(id: $profileId) {
      id
      isOwner
      csgo {
        progressionReport(limit: 9999) {
          ...ProgressionReportFields
        }
      }
    }
  }

  ${progressionReportFragments}
`
